import { defineStore } from 'pinia';
export const useWishlistStore = defineStore('wishlist', {
    state: () => ({
        wishlist: { items_count: 0 },
    }),
});
